import { render, staticRenderFns } from "./dict-edit.vue?vue&type=template&id=d477d312&scoped=true&"
import script from "./dict-edit.vue?vue&type=script&lang=js&"
export * from "./dict-edit.vue?vue&type=script&lang=js&"
import style0 from "./dict-edit.vue?vue&type=style&index=0&id=d477d312&lang=less&scoped=true&"
import style1 from "@/assets/less/i-switch.less?vue&type=style&index=1&id=d477d312&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d477d312",
  null
  
)

component.options.__file = "dict-edit.vue"
export default component.exports